import { WalletsAccountsClient } from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const walletAccountClient = new WalletsAccountsClient(
  apiConfig,
  undefined,
  axiosInstance
);

const handleGetMyWallets = async () => {
  try {
    const walletList = (await walletAccountClient.getAllMyWallets()).data;
    return walletList;
  } catch {
    return;
  }
};

export { handleGetMyWallets };
